import { useTranslation } from "react-i18next";
import { Card, Col, Row} from "react-bootstrap"
import { formatCnpj } from "../../../../../../../helpers";


export const CardCompanyDetail = (props: any): JSX.Element => {
    const { company } = props;
    const { t: translation } = useTranslation();
   
    return (
        <Card className="card-detail">
            <Card.Body>
                <Card.Title className="">
                    <Row>
                        <Col sm={6} className="d-flex align-items-center">
                            <h4 className="mb-0 text-darker-grey" style={{ fontSize: '22px' }}>{translation('userAccount.companyLabel')}</h4>
                        </Col>
                    </Row>
                </Card.Title>
                <Row className="mt-3 p-0">
                    <hr />
                </Row>
                <Row>
                    <Col md={12} className="d-flex align-items-center">
                        <Row className="col-12">
                            <Col xs={12} className="mb-2">
                                <Row>
                                    <Col md={9} lg={6}>
                                        <h6>
                                            <span className="text-darker-grey">{translation('userAccount.company.name')}: </span>
                                            {company && company.name ? company.name : "Não informado"}
                                        </h6>
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={12} className="mb-2">
                                <Row>
                                    <Col md={9} lg={6}>
                                        <h6>
                                            <span className="text-darker-grey">{translation('userAccount.company.fantasy')}: </span>
                                            {company && company.fantasy ? company.fantasy : "Não informado"}
                                        </h6>
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={12} className="mb-2">
                                <Row>
                                    <Col md={9} lg={6}>
                                        <h6>
                                            <span className="text-darker-grey">{translation('userAccount.company.cnpj')}: </span>
                                            {company && company.cnpj ? formatCnpj(company.cnpj) : "Não informado"}
                                        </h6>
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={12} className="mb-2">
                                <Row>
                                    <Col md={9} lg={6}>
                                        <h6>
                                            <span className="text-darker-grey">{translation('userAccount.company.address')}: </span>
                                            {
                                                company && company.address && company.address.public_space && company.address.number && company.address.district && company.address.city && company.address.state ? (
                                                    `${company.address.public_space}, ${company.address.number}, ${company.address.district} - ${company.address.city}-${company.address.state}`
                                                ) : "Não informado"
                                            }
                                        </h6>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    )
}